/* === Product Description "Read More" custom element === */
if (!customElements.get('t4s-product-description')) {
  class ProductDescription extends HTMLElement{
    constructor(){
      super();
      this.lm_btn = this.querySelector('.t4s-pr-des-rm');
      this.content = this.querySelector('[data-lm-content]');
      this.m_h_content = parseInt(this.getAttribute('data-height'));

      if(!this.lm_btn || !this.content || this.m_h_content < 0 ) return;
      setTimeout(() => {
        this.lm_btn.classList.toggle('is--show', parseInt(this.content.scrollHeight) > this.m_h_content);
      },500)
      this.lm_btn.addEventListener('click',()=>{
        this.classList.contains('is--less') ? this.content.style.setProperty('--m-h', `${this.m_h_content}px`) : this.content.style.setProperty('--m-h', `${this.content.scrollHeight}px`)
        this.classList.toggle('is--less');
      })
    }
  }
  customElements.define('t4s-product-description',ProductDescription);
}

/* === Biscuits Bundle Peek Animation === */
(function() {
  function initPeekAnimation() {
    var sliders = [document.querySelector('.biscuits-bundle-step__slider-container')];
    if (!sliders.length) {
      setTimeout(initPeekAnimation, 600);
      return;
    }

    sliders.forEach(function(slider) {
      if (slider.dataset.peekDone) return;
      slider.dataset.peekDone = '1';

      var parent = slider.parentElement;

      var nextBtn = parent.querySelector('.biscuits-bundle-slider-button--next');
      var prevBtn = parent.querySelector('.biscuits-bundle-slider-button--prev');
      if (!nextBtn) return;

      parent.style.position = 'relative';

      var hand = document.createElement('div');
      hand.style.cssText = 'position:absolute;top:50%;right:20px;transform:translateY(-50%);font-size:30px;z-index:99;pointer-events:none;opacity:0;transition:opacity 0.4s ease;animation:peekHand 1.2s ease-in-out infinite;';
      hand.innerHTML = '👆';
      parent.appendChild(hand);

      var triggered = false;
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !triggered) {
            triggered = true;
            runPeek(hand, nextBtn, prevBtn);
          }
        });
      }, { threshold: 0.6 });

      obs.observe(slider);
    });
  }

  function runPeek(hand, nextBtn, prevBtn) {
    setTimeout(function() {
      hand.style.opacity = '1';

      setTimeout(function() {
        nextBtn.click();
      }, 500);

      setTimeout(function() {
        if (prevBtn) prevBtn.click();
      }, 1500);

      setTimeout(function() {
        hand.style.opacity = '0';
      }, 2000);

    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initPeekAnimation, 900); });
  } else {
    setTimeout(initPeekAnimation, 900);
  }
})();
